import { useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { RxCross2 } from 'react-icons/rx';

import { CustomLoader } from '../../../services/Reducer';
import apiClient from '../../../api/apiClient';
import authServices from '../../../services/AuthServices';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

const Add_table = ({ show, toggle, refreshData, AddcurrentPage }) => {
  const [formData, setFormData] = useState({
    deviceUsername: '',
    devicePassword: '',
    mid: '',
    tid: '',
    userId: '',

  });
  const [errors, setErrors] = useState({}); // Error state
  const dispatch = useDispatch();

  const loader = (display) => {
    dispatch(CustomLoader(display));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Clear the error for the field being edited
    setErrors({ ...errors, [name]: '' });
  };

  const validateForm = () => {
    let formErrors = {};

    if (formData.deviceUsername === '') {
      formErrors.deviceUsername = 'deviceUsername cannot be empty';
    }
    if (formData.devicePassword === '') {
      formErrors.devicePassword = 'devicePassword cannot be empty';
    }
    if (formData.mid === '') {
      formErrors.mid = 'mid cannot be empty';
    }
    if (formData.tid === '') {
      formErrors.tid = 'tid cannot be empty';
    }
    if (formData.userId === '') {
      formErrors.userId = 'userId cannot be empty';
    }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0; // No errors
  };

  const token = authServices.getToken();
  const handleSubmit = async (e) => {
    // e.preventDefault();
    if (!validateForm()) {
      return; // Stop submission if there are validation errors
    }

    loader('enable');

    try {

      const response = await apiClient.post('/api/admin/device_config/add', formData, {

        headers: {
          'access_token': token,
        },

      });

      if (response.data.Status === "SUCCESS") {
        setFormData({

          deviceUsername: '',
          devicePassword: '',
          mid: '',
          tid: '',
          userId: '',

        });
      }
      else {
        console.log(response.data.message)
      }
    }
    catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      refreshData(AddcurrentPage);
      loader('disable');
      toggle(); // Close the modal after submission
      // window.location.reload();
    }
  };

  // ************************************************ Get User Data ***********************************************************
  const [data, setData] = useState([]);

  const fetchPortId = async () => {
    try {
      const response = await apiClient.get(`/api/admin/users/getByUserType?userType=user&pageNumber=0&pageSize=200`, {
        params: {
          pageNumber: 0,
          pageSize: 200,
        },
        headers: {
          'access_token': token,
        }
      }
      );
      setData(response.data.data.records);

    } catch (err) {
      console.error('Error fetching data:', err);
    }
  };

  const filteredData = Array.from(
    new Map(data.map((item) => [item.name, item])).values()
  );

  const validData = filteredData.filter((item) => item.name);


  useEffect(() => {
    fetchPortId()

  }, []);


  return (
    <>
      {show && (
        <>
          <div className="modal fade show d-block" id="exampleModalScrollable" tabIndex={-1} role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
            <div className="modal-dialog modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalScrollableTitle">Add device_config</h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={toggle} >< RxCross2 /></button>
                </div>
                <div className="modal-body-custom">
                  <form >

                    <div className="row">
                      <div className="spacing w-50 d-inline-block">
                        <label htmlFor="deviceUsername" className="label-custom">Device Username</label>
                        <input
                          type="text"
                          className={`input-custom ${errors.deviceUsername ? 'input-error' : ''}`}
                          id="deviceUsername"
                          name="deviceUsername"
                          value={formData.deviceUsername}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="spacing w-50 d-inline-block">

                        <label htmlFor="userId" className="label-custom">UserId</label>
                        <Autocomplete
                          // className={` ${errors.userId ? 'input-error' : ''}`}
                          disablePortal
                          options={validData} // Full user object
                          getOptionLabel={(option) => option.name} // Show 'name' in dropdown
                          getOptionSelected={(option, value) => option.id === value.id} // Ensure unique selection
                          renderInput={(params) => <TextField {...params} label="" />}
                          onChange={(event, value) => {
                            if (value) {
                              setFormData({ ...formData, userId: value.id }); // Save 'id' in state
                            } else {
                              setFormData({ ...formData, userId: "" }); // Reset state
                            }
                          }}
                          // Key attribute setup using 'id'
                          renderOption={(props, option) => (
                            <li {...props} key={option.id}>
                              {option.name}
                            </li>
                          )}
                          // Scroll enable kare inline style ke sath
                          componentsProps={{
                            paper: {
                              style: {
                                maxHeight: '130px', // Dropdown ki maximum height
                                overflowY: 'auto',  // Scroll enable karega
                              },
                            },
                          }}
                        />
                        {errors.portId && <span className="text-danger">{errors.portId}</span>}

                      </div>

                    </div>

                    <div className="row">
                      <div className="spacing w-50 d-inline-block">
                        <label htmlFor="mid" className="label-custom">MID</label>
                        <input
                          type="text"
                          className={`input-custom ${errors.mid ? 'input-error' : ''}`}
                          id="mid"
                          name="mid"
                          value={formData.mid}
                          onChange={handleChange}
                        // placeholder="Enter Amount"
                        />
                      </div>
                      <div className="spacing w-50 d-inline-block">
                        <label htmlFor="tid" className="label-custom">TID</label>
                        <input
                          type="text"
                          className={`input-custom ${errors.tid ? 'input-error' : ''}`}
                          id="tid"
                          name="tid"
                          value={formData.tid}
                          onChange={handleChange}
                        // placeholder="Enter Amount"
                        />
                      </div>
                    </div>


                    <div className="row">
                      <div className="spacing" >
                        <label htmlFor="devicePassword" className="label-custom">Device Password</label>
                        <input
                          type="text"
                          className={`input-custom ${errors.devicePassword ? 'input-error' : ''}`}
                          id="devicePassword"
                          name="devicePassword"
                          value={formData.devicePassword}
                          onChange={handleChange}
                        // placeholder="Enter Billing Name"
                        />
                      </div>

                    </div>

                  </form>
                </div>

                <div className="modal-footer">

                  <button type="button" style={{ backgroundColor: '#F0F0F0', color: '#000', fontWeight: '500', border: "1px solid #d7dde2" }} className="btn " data-bs-dismiss="modal" onClick={toggle}>
                    Close
                  </button>
                  <button type="button" style={{ color: 'white', fontWeight: '500' }} className="btn btn-primary" onClick={handleSubmit}>
                    Submit
                  </button>

                </div>
              </div>
              {/* /.modal-content */}
            </div>
            {/* /.modal-dialog */}
          </div>
          {/* /.modal */}
        </>
      )}
    </>
  );
};

export default Add_table;
